import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Button, Header, Modal } from 'semantic-ui-react';
import {
  showDeleteConfirmationModal,
  deleteDiscountRule,
} from 'state/discountRule/actions';

const DeleteDiscountRuleModal = props => {
  const { dispatch, deleteConfirmation } = props;

  const handleOnCancelButtonClick = () => {
    dispatch(showDeleteConfirmationModal(false, null));
  };

  const handleOnOKButtonClick = () => {
    dispatch(deleteDiscountRule(deleteConfirmation.deleteingRule.id));
    dispatch(showDeleteConfirmationModal(false, null));
  };

  return (
    <Modal
      closeIcon
      open={deleteConfirmation.isOpen}
      onClose={handleOnCancelButtonClick}
    >
      <Header icon="trash alternate" content="Delete Confirm" />
      <Modal.Content>
        <p>
          Are you sure you want to delete discount rule
          <b>
            {' '}
            {deleteConfirmation.deleteingRule &&
              deleteConfirmation.deleteingRule.name}
          </b>
          ?
        </p>
      </Modal.Content>
      <Modal.Actions>
        <Button basic color="black" onClick={handleOnCancelButtonClick}>
          Cancel
        </Button>
        <Button color="red" onClick={handleOnOKButtonClick}>
          OK
        </Button>
      </Modal.Actions>
    </Modal>
  );
};

const mapStateToProps = ({ discountRule }) => ({
  deleteConfirmation: discountRule.deleteConfirmation,
});

DeleteDiscountRuleModal.propTypes = {
  dispatch: PropTypes.func.isRequired,
  deleteConfirmation: PropTypes.shape({
    isOpen: PropTypes.bool,
    isLoading: PropTypes.bool,
    deleteingRule: PropTypes.object,
  }).isRequired,
};

export default connect(mapStateToProps)(DeleteDiscountRuleModal);
